import { Box } from '@coolblue-development/becky';
import { useEffect, useRef } from 'react';
import { useChatContext } from '../../../../../contexts/ChatContext';
import getCurrentTime from '../../../../../utils/timeFactory';
import ChatTab from '../ContactTab/ChatTab';
import { datadogLogs } from '@datadog/browser-logs';
import postEvent from '../../../../../services/postEvent';
import { useAppContext } from '../../../../../AppContext';
import { CHAT_FOCUS_TIMESTAMP_KEY } from '../../../../../constants/localStorage';

const ChatSidePanel = (): JSX.Element => {
  const { selectedChat, chatContacts } = useChatContext();
  const { agent } = useAppContext();
  const prevContactId = useRef<string | null>(null);

  useEffect(() => {
    const currentTime = getCurrentTime();

    if (prevContactId.current) {
      const previousTimestamp = localStorage.getItem(CHAT_FOCUS_TIMESTAMP_KEY);

      if (previousTimestamp) {
        void postEvent(
          prevContactId.current,
          'focus',
          {
            startedAt: new Date(JSON.parse(previousTimestamp) as string),
            endedAt: currentTime
          },
          'CHAT'
        ).catch((error: Error) => {
          const agentName = agent?.getName();
          datadogLogs.logger.warn('Failed to post focus event', { error, agent: agentName });
        });
      }
    }

    localStorage.setItem(CHAT_FOCUS_TIMESTAMP_KEY, JSON.stringify(currentTime));

    prevContactId.current = selectedChat;
  }, [selectedChat]);

  return (
    <Box>
      {chatContacts?.map(contact => (
        <ChatTab key={contact} contactId={contact} />
      ))}
    </Box>
  );
};

export default ChatSidePanel;
